import * as React from 'react'
import { mergeStyles, StylesConfig } from 'react-select'
import { selectCustomStyles, invalidStateStyles } from './select.styles'

export const useSelectStyles = function (
  invalid: boolean,
  customStyles: Partial<StylesConfig>
): Partial<StylesConfig> {
  return React.useMemo(() => {
    let styles: Partial<StylesConfig> = selectCustomStyles

    if (invalid) {
      styles = mergeStyles(styles, invalidStateStyles)
    }

    return mergeStyles(styles, customStyles)
  }, [invalid, customStyles])
}
